<template>
    <div class="container-fluid">
        <modal-x :show="isSelectingImage" @onclose="isSelectingImage=false">
            <image-list v-if="isSelectingImage" :user-id="shopUserId" @onselect="onImgSelect"></image-list>
        </modal-x>
        <modal-x :show="showCats" :content-style="{ maxWidth: '800px' }" @onclose="showCats = false">
            <category-tree v-if="showCats" :selected="selectedCatIds" :cat-node="catNode"
                v-on:catSelected="catSelectUpdated" :viewMode="{}" :expand-all="true"></category-tree>
        </modal-x>
        <modal-x :show="showTags" :content-style="{ maxWidth: '800px' }" @onclose="showTags = false">
            <category-tree v-if="showTags" :selected="selectedTagIds" :cat-node="tagNode"
                v-on:catSelected="tagSelectUpdated" :viewMode="{}" :expand-all="true"></category-tree>
        </modal-x>
        
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">Content Configuration</h4>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-md-8">
                        <!-- Image Section -->
                        <div class="form-group">
                            <label class="control-label">Image</label>
                            <div class="row">
                                <div class="col-xs-3">
                                    <img :src="retObj.image" class="img-thumbnail" style="width:100px;height:100px;" />
                                </div>
                                <div class="col-xs-9">
                                    <div class="input-group">
                                        <input class="form-control" type="text" v-model="retObj.image" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-default" type="button" @click="selectImg(setNewLabelImg)">Select Image</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Title and Message -->
                        <div class="form-group">
                            <label class="control-label">Title</label>
                            <input class="form-control" type="text" v-model="retObj.title" />
                        </div>
                        <div class="form-group">
                            <label class="control-label">Message</label>
                            <textarea class="form-control" rows="3" v-model="retObj.msg"></textarea>
                        </div>
                        
                        <!-- Category/Tag Selection -->
                        <div class="form-group">
                            <div class="text-right">
                                <button class="btn btn-primary" @click="editCats">Select Categories</button>
                                <button class="btn btn-info" @click="editTags">Select Tags</button>
                                </div>
                        </div>
                        
                        <!-- CatSubType and CardView -->
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label">Category SubType</label>
                                    <select v-model.number="retObj.catSubType" class="form-control">
                                        <option value="-1">Please Select</option>
                                        <option value="0">Product Page</option>
                                        <option value="1">Article Page</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label">Card View</label>
                                    <select v-model="retObj.cardView" class="form-control">
                                        <option value="">Please Select</option>
                                        <option value="info">Info</option>
                                        <option value="infoText">Info Text</option>
                                        <option value="sale">Sale</option>
                                        <option value="text">Text</option>
                                        <option value="banner">Banner</option>
                                        <option value="bigBanner">Big Banner</option>
                                        <option value="link">Link</option>
                                        <option value="media">Media</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Page Size and Default Page -->
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label">Page Size</label>
                                    <input class="form-control" type="number" v-model.number="retObj.pageSize" />
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label">Default Page (when there is no paging buttons)</label>
                                    <input class="form-control" type="number" v-model.number="retObj.page" />
                                </div>
                            </div>
                        </div>
                        
                        <!-- Hide Paging and Get Links -->
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        <input type="checkbox" v-model="retObj.hidePaging" /> Hide Paging
                                    </label>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        <input type="checkbox" v-model="retObj.getLinks" /> Get Links
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- JSON Preview -->
                    <div class="col-xs-12 col-md-4">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h5 class="panel-title">Preview</h5>
                            </div>
                            <div class="panel-body">
                                <pre style="background:#f5f5f5;padding:10px;border-radius:4px;">{{ retObj }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="text-center">
            <button class="btn btn-success btn-lg" @click="save">Done</button>
        </div>
    </div>
</template>
<script>
import CategoryTree from '../components/CategoryTree.vue';
import imageList from './imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import apis from '../api/extApi.js';

export default {
    components: {
        CategoryTree: CategoryTree,
        imageList: imageList,
        modalX: modalX
    },
    props: ["shopUserId", "initData"],
    computed: {

    },
    data: function () {
        return {
            apiClient: apis.api,
            catCodes: apis.api.settings.catCodes,
            uiClient: null,
            imgHandler: null,
            isSelectingImage: false,
            selectedImgs: [],
            retObj: this.initData === null ? {} : this.initData,
            selectedCatIds: { catIds: [], timestamp: 0 },
            selectedTagIds: { catIds: [], timestamp: 0 },
            showCats: false,
            catNode: null,
            showTags: false,
            tagNode: null
        };
    },
    methods: {
        save: function () {
            this.$emit("onsave", this.retObj);
        },
        getArrayFromCsv: function (val) {
            if (val && val !== null) {
                return val.split(',');
            }
            return [];
        },
        editTags: function () {
            this.apiClient.getCategoryNodePrms(this.catCodes.tag, this.shopUserId).done((ret) => {
                console.log('cat node', ret);
                this.tagNode = ret;
                this.showTags = true;
            });

        },
        tagSelectUpdated(ret) {
            console.log("cat update", ret);
            var catIds = this.retObj.tags;
            if (!catIds) {
                catIds = [];
                this.retObj.tags = catIds;
            }
            var index = catIds.indexOf(ret.child.catId);
            if (index >= 0) {
                this.retObj.tags.splice(index, 1);
            } else {
                this.retObj.tags.push(ret.child.catId);
            }
            this.selectedTagIds.catIds = this.retObj.tags;
            this.selectedTagIds.timestamp = Date.now();
        },
        catSelectUpdated(ret) {
            console.log("cat update", ret);
            var catIds = this.retObj.cats;
            if (!catIds) {
                catIds = [];
                this.retObj.cats = catIds;
            }
            var index = catIds.indexOf(ret.child.catId);
            if (index >= 0) {
                this.retObj.cats.splice(index, 1);
            } else {
                this.retObj.cats.push(ret.child.catId);
            }
            this.selectedCatIds.catIds = this.retObj.cats;
            this.selectedCatIds.timestamp = Date.now();
        },
        editCats: function () {
            this.apiClient.getCategoryNodePrms(this.catCodes.listing, this.shopUserId).done((ret) => {
                console.log('cat node', ret);
                this.catNode = ret;
                this.showCats = true;
            });
        },
        onImgSelect: function (imgFile) {
            this.selectedImgs.push(imgFile);
            this.imgHandler(imgFile, this.selectedImgs);
        },
        setNewLabelImg: function (newImg) {
            this.retObj.image = newImg.thumbPath;
            this.isSelectingImage = false;
        },
        selectImg: function (handler) {
            this.imgHandler = handler;
            this.isSelectingImage = !this.isSelectingImage;
        }
    },
    created: function () {

    },
    mounted: function () {
        console.log("jsonData userid", this.shopUserId);
        if (this.retObj.cats) {
            this.selectedCatIds.catIds = this.retObj.cats;
            this.selectedCatIds.timestamp = Date.now();
        }
        this.uiClient = apis.ui.getShopClient({ userId: this.shopUserId });
    },
    destroyed: function () {
        this.uiClient.destroy();
    }
}
</script>